import React from 'react';
import { KAKAO_TALK_URL } from '../constants/contact';

interface FooterProps {
  onScrollToTop: () => void;
}

const Footer: React.FC<FooterProps> = ({ onScrollToTop }) => (
  <footer className="border-t border-slate-200 bg-white py-12 text-slate-950">
    <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-9 px-4 md:grid-cols-[minmax(0,1.35fr)_minmax(130px,0.5fr)_minmax(180px,0.65fr)] md:gap-x-8 md:gap-y-10">
      <div>
        <div className="mb-4 flex items-center gap-3">
          <img
            src="/brand-concepts/som/shift-05a-register.svg"
            alt="솜니움라이브 로고"
            className="h-12 w-12 object-contain"
          />
          <div>
            <h3 className="text-lg font-bold tracking-[0.16em] text-slate-950">SOMNIUM LIVE</h3>
            <p className="text-xs font-medium text-slate-500">Web · App · Backend Development</p>
          </div>
        </div>
        <p className="max-w-md text-sm leading-7 text-slate-600">
       IT 서비스 기획부터 개발·운영까지 함께하는 기술 파트너입니다.
        </p>
        <div className="mt-6 space-y-1 text-sm leading-relaxed text-slate-600">
          <p>사업자등록번호 627-06-03425</p>
          <p>대표자 김은수</p>
          <p>주소 경기 성남시 분당구 서현로 210번길 20 405호</p>
          <p>이메일 contact@somniumlive.com</p>
        </div>
      </div>

      <div>
        <h3 className="mb-4 text-lg font-bold">바로가기</h3>
        <ul className="space-y-3 text-sm text-slate-600">
          <li>
            <button type="button" onClick={onScrollToTop} className="hover:text-[#005322]">
              맨 위로
            </button>
          </li>
          <li>
            <a href="/#services" className="hover:text-[#005322]">
              서비스 소개
            </a>
          </li>
          <li>
            <a href="/#portfolio" className="hover:text-[#005322]">
              주요 작업
            </a>
          </li>
          <li>
            <a href="/#tech" className="hover:text-[#005322]">
              기술 역량
            </a>
          </li>
          <li>
            <a href="/#contact" className="hover:text-[#005322]">
              문의하기
            </a>
          </li>
        </ul>
      </div>

      <div>
        <h3 className="mb-4 text-lg font-bold">채널</h3>
        <ul className="space-y-3 text-sm text-slate-600">
          <li>
            <a
              href={KAKAO_TALK_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#005322]"
            >
              카카오톡 문의
            </a>
          </li>
          <li>
            <a
              href="https://m.blog.naver.com/somniumlive"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#005322]"
            >
              네이버 블로그
            </a>
          </li>
          <li>
            <a href="mailto:contact@somniumlive.com" className="hover:text-[#005322]">
              contact@somniumlive.com
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div className="mx-auto mt-10 max-w-[1200px] border-t border-slate-200 px-4 pt-6 text-sm text-slate-500">
      &copy; {new Date().getFullYear()} SOMNIUM LIVE. All rights reserved.
    </div>
  </footer>
);

export default Footer;
